// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-774ff630] .compact-control {\n  padding-bottom: 0px;\n  padding-top: 0px;\n  padding-left: 2px;\n  height: 1.5rem;\n  width: 150px;\n}\n[data-v-774ff630] .compact-container {\n  width: 150px;\n}\n[data-v-774ff630] .short-expandable-control {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 2.25rem;\n  min-height: 2.25rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
